import { render, staticRenderFns } from "./pingjia.vue?vue&type=template&id=35099ab7&scoped=true&"
import script from "./pingjia.vue?vue&type=script&lang=js&"
export * from "./pingjia.vue?vue&type=script&lang=js&"
import style0 from "./pingjia.vue?vue&type=style&index=0&id=35099ab7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35099ab7",
  null
  
)

export default component.exports